import { useEffect } from 'react';
import { useUploadStore } from '@/store/uploadStore';

export function UploadGuard() {
  const hasUploads = useUploadStore(s =>
    Object.values(s.slots).some(slot => slot.status === 'uploading'),
  );

  useEffect(() => {
    if (!hasUploads) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUploads]);

  return null;
}
